<template>
  <v-row>
    <v-col cols="12" class="header text-center white mt-n8">
      <div class="subheader">
        <v-btn class="back" text small color="primary" @click="backToModules">
          <v-icon small class="mr-2">mdi-arrow-left</v-icon>
          Back To Modules
        </v-btn>
      </div>

      <div class="display-1 py-4">{{ module.title }}</div>
      <v-divider />
    </v-col>

    <div class="items px-6 py-4" v-if="module.items && module.items.length > 0">
      <jump-start-item
        v-for="item in module.items"
        :key="item.title"
        :item="item"
      ></jump-start-item>
    </div>

    <div v-else class="text-center font-bold px-7 py-7" style="font-size:20px; width: 100%">
      Folder is empty
    </div>
  </v-row>
</template>

<script>
import JumpStartItem from './Item.vue';

export default {
  name: 'JumpStartFolder',
  components: { JumpStartItem },
  props: ['module'],
  data: () => ({}),
  methods: {
    backToModules() {
      this.$router.push('/jump-start')
    },
  }
}
</script>

<style>
.header {
  position: sticky;
  top: 60px;
  z-index: 1;
}

.subheader {
  position: absolute;
  top: 35px;
  left: 15px;
}

.items {
  width: 100%;
}
</style>